import type { ChartData, DataPoint } from '../chartsModule/types'
import type { AnalyticsReportData } from '../types'
import { extractPrimitiveValue } from './extractPrimitiveValue'

export const createAnalyticsChartData = ({
  reportData,
  activeSeries,
}: {
  reportData: AnalyticsReportData | undefined
  activeSeries: string
}): ChartData[] => {
  if (!reportData?.report || !reportData.report.rows.length) {
    return []
  }

  const data: ChartData = {
    label: '',
    data: reportData.report.rows.map((row) => {
      const seriesProperty = row[activeSeries]

      return {
        value: extractPrimitiveValue(seriesProperty),
        label: Object.values(row)[0],
      } as DataPoint
    }),
  }

  return [data]
}
